import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import PainelDispositivoView from "@/views/PainelDispositivoView.vue";
import { sso } from "roboflex-thalamus-sso-lib";
import { consumiuReloadPorTrocaTenant } from "roboflex-thalamus-request-handler";
import { limparDispositivoSelecionadoStorage } from "@/utils/dispositivo-storage";

export class RoutesName {
  static home = "home";
  static painelDispositivo = "painelDispositivo";
}

function sendUserToPortal() {
  const buildMode = process.env.NODE_ENV;
  if (buildMode == "production") {
    window.location.href = "https://portal.thalamus.ind.br/#/";
  } else {
    window.location.href = "https://portal-homologacao.thalamus.ind.br/#/";
  }
}

// valida se esta logado
async function guardMyroute(to, from, next) {
  const isValid = sso.validarSessao();

  if (isValid) {
    next();
  } else {
    sendUserToPortal();
  }
}

const routes = [
  {
    path: "/",
    name: RoutesName.home,
    component: HomeView,
  },
  {
    path: "/painelDispositivo",
    name: RoutesName.painelDispositivo,
    component: PainelDispositivoView,
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(),
  routes,
});

/** Após reload por troca de tenant, evita painel com dispositivo de outra empresa. */
router.beforeEach((to, _from, next) => {
  if (!consumiuReloadPorTrocaTenant()) {
    next();
    return;
  }
  limparDispositivoSelecionadoStorage();
  if (to.name === RoutesName.painelDispositivo) {
    next({ name: RoutesName.home });
    return;
  }
  next();
});

router.beforeEach(guardMyroute);

export default router;
